var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectErrorOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4062 16 16 12.4375 16 8C16 3.59375 12.4062 0 8 0C3.5625 0 0 3.59375 0 8C0 12.4375 3.5625 16 8 16ZM8.53125 3.21875L12.0312 6.71875L12.5625 7.25L11.5 8.3125L10.9688 7.78125L8.75 5.5625V12.25V13H7.25V12.25V5.5625L5.03125 7.78125L4.5 8.3125L3.4375 7.25L3.96875 6.71875L7.46875 3.21875L8 2.6875L8.53125 3.21875Z",
    fill: "#FFA500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectErrorOrange);
export default __webpack_public_path__ + "static/media/project_error_orange.8db3dd43e3dba89bc2bd5d1a4cfc326c.svg";
export { ForwardRef as ReactComponent };